import { useState, useRef, useEffect } from 'react';

const DateRangeInput = ({
  name,
  onChange,
  placeholder = 'Select date range',
  inputClassName = '',
  label = 'Date Range'
}) => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [showPicker, setShowPicker] = useState(false);
  const wrapperRef = useRef(null);

  const formattedRange = fromDate && toDate ? `${fromDate} to ${toDate}` : '';

  const handleSelect = (from, to) => {
    const value = from && to ? `${from} to ${to}` : '';
    onChange?.({ target: { name, value } });
  };

  const handleClear = () => {
    setFromDate('');
    setToDate('');
    handleSelect('', '');
  };

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={wrapperRef} style={{ position: 'relative', width: '100%' }}>
      <div style={{ position: 'relative' }}>
        <input
          type="text"
          readOnly
          className={`form-control ${inputClassName} form-control inputdesign`}
          value={formattedRange}
          placeholder=" "
          onClick={() => setShowPicker(!showPicker)}
          style={{
            cursor: 'pointer',
            fontSize: '14px',
              padding: '8px 30px 8px 12px',
            // border: '1px solid #ccc',
            // borderRadius: '5px',
            width: '100%',
            background: '#fff',
             height: '32px',
            lineHeight: '1',
            // backgroundColor : 'red'
          }}
        />
  {/* Floating Label */}
  <label
    style={{
      position: 'absolute',
      top: formattedRange ? '-6px' : '6px',
      left: '8px',
      fontSize: formattedRange ? '0.6rem' : '0.7rem',
      color: '#666',
      background: '#fff',
      padding: '0 4px',
      transition: 'all 0.2s ease',
      pointerEvents: 'none',
    }}
  >
    {label}
  </label>


{!formattedRange && (
  <span
    style={{
      position: 'absolute',
      top: '50%',
      right: '8px',
      transform: 'translateY(-50%)',
      fontSize: '0.85rem',
      color: '#999',
      pointerEvents: 'none',
      fontFamily: 'monospace',
    }}
  >
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#555"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
  style={{
    position: 'absolute',
    top: '50%',
    right: '8px',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
  }}
>
  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
  <line x1="16" y1="2" x2="16" y2="6" />
  <line x1="8" y1="2" x2="8" y2="6" />
  <line x1="3" y1="10" x2="21" y2="10" />
  <circle cx="8" cy="14" r="1" />
  <circle cx="12" cy="14" r="1" />
  <circle cx="16" cy="14" r="1" />
</svg>

  </span>
)}



        {formattedRange && (
          <button
            type="button"
            onClick={handleClear}
            style={{
              position: 'absolute',
              top: '50%',
              right: '6px',
              transform: 'translateY(-50%)',
              background: 'transparent',
              border: 'none',
              fontSize: '0.9rem',
              color: '#aaa',
              cursor: 'pointer',
              padding: 0,
              lineHeight: '1',
            }}
          >
            ×
          </button>
        )}
      </div>

      {showPicker && (
        <div
          style={{
            position: 'absolute',
            top: '102%',
            left: 0,
            background: '#fff',
            border: '1px solid #ddd',
            padding: '6px',
            borderRadius: '0.4rem',
            boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
            zIndex: 1000,
            display: 'flex',
            gap: '4px',
            minWidth: '200px',
          }}
        >
          <input
            type="date"
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);
              handleSelect(e.target.value, toDate);
            }}
            className={inputClassName}
            style={{
              fontSize: '0.7rem',
              padding: '2px',
              borderRadius: '0.3rem',
              border: '1px solid #ccc',
              flex: 1,
            }}
          />
          <span style={{ fontSize: '0.7rem',marginTop : '1px', color: '#666' }}> ↔</span>
          <input
            type="date"
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
              handleSelect(fromDate, e.target.value);
            }}
            className={inputClassName}
            style={{
              fontSize: '0.7rem',
              padding: '2px',
              borderRadius: '0.3rem',
              border: '1px solid #ccc',
              flex: 1,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeInput;
